export const init = ({
	config: {
		sizebay: { scriptSrc, tenantId },
	},
}) => {
	window?.Sizebay
		? true
		: scriptSrc && tenantId
		? new Promise((resolve, reject) => {
				const scriptToAdd = document.createElement('script')
				scriptToAdd.src = scriptSrc
				scriptToAdd.onload = resolve
				scriptToAdd.onerror = reject
				scriptToAdd.setAttribute('id', 'sizebayScript')
				document.body.appendChild(scriptToAdd)
		  })
		: Promise.resolve()
}
